import { Box, Grid } from '@mui/material';
import {MoneyOffCsredOutlined} from '@mui/icons-material';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';

let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchVille: Params = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 }

const Tab2 = (props: { form?: any }) => {
  return (
    <div className='tabItem'>
      <div >
        <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
          <Box fontStyle="inherit" className='border-left border'>

            <legend>Adresse Client</legend>

            <SearInputM  width={4}  Titre='Recherche Type Adresse' label='Type Adresse' name="TYPADR" Parametre={searchTypAdr} form={props.form} />
            <SearInputM  width={4}  Titre='Recherche Ville' label='Ville' name="vilCli" Parametre={searchVille} form={props.form} />

            <Grid container spacing={0}>
              <Grid item xs={12} sm={6}>
                <InputForm width={10} notRequired label='Boite Postale' name='adrPostal' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} label='Téléphone Mobile 1' name='telCli' type='number' error=' ce Champ est obligatiore' RegExp={/[0-9]{9}$/gmi} MessExp='le numéro doit étre de 9 chiffres'   />
                <InputForm notRequired width={10} label='Téléphone Mobile 2' name='Tel2' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Faxcli' name='FaxCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputForm width={10} label='Nom du quatier' name='nomQtier' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Numéro Rue' name='rueCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Adresse Email' name='EmailCli' type='email' error=' ce Champ est obligatiore' />
                <InputForm notRequired width={10} label='Adresse Domicile' name='NumDomCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Box>

          <Box fontStyle="inherit" className='border-left border'>

            <legend>Information Employeur/Famille</legend>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={6}>
                <InputForm width={10} notRequired label='Nombre Enfant' name='nbrEnfant' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Nbre Personne à charge' name='nbrPersCharge' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Nom Employeur' name='NOMEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Matricule Employeur' name='MATEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='No Contribuable' name='NOCONT' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Nom du père' name='nompere' type='text' error=' ce Champ est obligatiore' />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputForm width={10} money   notRequired label='Revenu mensuel' name='revenuCli' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Adresse Employeur' name='ADREMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Numéro CNPS' name='NOCNPS' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} notRequired label='Adresse Internet' name='numCnet' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} label='Profession' name='profesion' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} label='Nom de la mère' name='nommere' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Grid container spacing={0} className='border-left bordure1 tabElement2'>
          <Grid item xs={12} sm={4}>
            <InputForm notRequired disabled  width={10} label='UTILISATEUR  CREE' name='UTILIS' defaultValue='' type='text' error='mobile' />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputForm notRequired disabled  width={10} label='UTILISATEUR  VALIDE' name='UTILVAL' defaultValue='' type='text' error='mobile' />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputForm notRequired disabled  width={10} label='DATE CREATION' name='DATCRE' defaultValue='' type='text' error='mobile' />
          </Grid>
        </Grid>
      </div>
    </div>

  );

}

export default Tab2;